/**
 * Preferences UI in Offcanvas
 * Interactions
 */

class Preferences {
  userPreferences = {};
  key = "user_preferences";

  constructor() {
    this.loadFromLocalStorage();
    this.bindEvents();
    // this.initDefaultValuesFromLocalStoredPreferences();

    this.init();
  }

  bindEvents() {
    document
      .querySelector("#contentFontSize")
      .addEventListener("input", this.updateFontSize.bind(this));
  }

  updateFontSize() {
    let userFontSize = document.querySelector("#contentFontSize").value;
    // console.log(userFontSize);
    this.userPreferences["contentFontSize"] = userFontSize;
    this.saveUserPreferences();

    document.querySelectorAll(".text-content").forEach((element) => {
      element.style.fontSize = userFontSize + "pt";
    });

    document.querySelector("#fontSizeDisplay").textContent = userFontSize;
  }

  loadFromLocalStorage() {
    let localData = localStorage.getItem(this.key);
    if(localData == null) {
      this.userPreferencesSetDefault();
    } else {
      this.userPreferences = JSON.parse(localData);
    }
    console.log(this.userPreferences);
    
  }

  userPreferencesSetDefault() {
    this.userPreferences = {};
    this.userPreferences["contentFontSize"] = 18;    
    this.saveUserPreferences();
  }

  saveUserPreferences() {
    localStorage.setItem(this.key, JSON.stringify(this.userPreferences));
  }

  initDefaultValuesFromLocalStoredPreferences() {
    console.log(this.userPreferences);
    document.querySelector("#contentFontSize").value =
      this.userPreferences["contentFontSize"];

    // Create a new input event
    let inputEvent = new Event("input", {
      bubbles: true, // Allows the event to bubble up through the DOM
      cancelable: true, // Allows the event to be canceled
    });
    document.querySelector("#contentFontSize").dispatchEvent(inputEvent);
  }

  init() {
    this.initDefaultValuesFromLocalStoredPreferences();
    this.updateFontSize();
    return true;
  }
}

document.addEventListener("DOMContentLoaded", initPreference);

function initPreference() {
  if (document.querySelector("#user_preferences_offcanvas")) {
    new Preferences();
  } else {
    Preferences = null;
  }
}
